import { render } from "./BuildTestsPage.vue?vue&type=template&id=ff1f4092"
import script from "./BuildTestsPage.vue?vue&type=script&lang=js"
export * from "./BuildTestsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__